// Build Your Evening — static data: menus and wines list
// Prices are in EUR. "deposit" is always €50 upfront via Stripe; the rest is paid on the night.

export const BYE_EXPERIENCES = ["coppie", "gruppo"];

// Menus override the per-person price (Option B agreed with chef).
export const BYE_MENUS = [
  { key: "tradizione", price: 170 },
  { key: "pesce", price: 200 },
  { key: "tartufo", price: 300, badge: true },
];

// Wines list (identical to the HTML brief). Prices in EUR per bottle.
// Shared across all languages (names are proper nouns).
export const BYE_WINES = [
  // White
  { id: "frascati",     cat: "white", name: "Frascati Superiore",             region: "Lazio",      note: "dry, light & fresh",  price: 25 },
  { id: "verdicchio",   cat: "white", name: "Verdicchio Casal di Serra",      region: "Marche",     note: "dry, crisp",          price: 28 },
  { id: "falanghina",   cat: "white", name: "Falanghina",                     region: "Campania",   note: "dry, fruity",         price: 30 },
  { id: "vermentino",   cat: "white", name: "Vermentino Costamolino",         region: "Sardegna",   note: "dry, light",          price: 30 },
  { id: "gavi",         cat: "white", name: "Gavi di Gavi",                   region: "Piemonte",   note: "dry, elegant",        price: 40 },
  { id: "pinot_grigio", cat: "white", name: "Pinot Grigio Santa Margherita",  region: "Veneto",     note: "dry, soft",           price: 45 },
  // Red
  { id: "montepulciano",cat: "red",   name: "Montepulciano d'Abruzzo",        region: "Abruzzo",    note: "medium-bodied, soft", price: 25 },
  { id: "nero_davola",  cat: "red",   name: "Nero d'Avola Planeta",           region: "Sicilia",    note: "medium-bodied, fruity", price: 30 },
  { id: "chianti",      cat: "red",   name: "Chianti Classico",               region: "Toscana",    note: "medium-bodied, dry",  price: 38 },
  { id: "ripasso",      cat: "red",   name: "Valpolicella Ripasso Campofiorin",region:"Veneto",     note: "full-bodied, rich",   price: 40 },
  { id: "barolo",       cat: "red",   name: "Barolo",                         region: "Piemonte",   note: "full-bodied, structured", price: 65 },
  { id: "brunello",     cat: "red",   name: "Brunello di Montalcino",         region: "Toscana",    note: "full-bodied, aged",   price: 85 },
  // Rosé
  { id: "five_roses",   cat: "rose",  name: "Five Roses",                     region: "Puglia",     note: "dry, fruity",         price: 30 },
  { id: "whispering",   cat: "rose",  name: "Whispering Angel",               region: "Provence",   note: "dry, delicate",       price: 50 },
  // Sparkling
  { id: "prosecco",     cat: "sparkling", name: "Prosecco DOC",               region: "Veneto",     note: "dry, light",          price: 25 },
  { id: "prosecco_sup", cat: "sparkling", name: "Prosecco Superiore Valdobbiadene", region: "Veneto", note: "finer bubbles",     price: 38 },
  { id: "franciacorta", cat: "sparkling", name: "Franciacorta",               region: "Lombardia",  note: "metodo classico",     price: 75 },
  // Champagne
  { id: "moet",         cat: "champagne", name: "Moët & Chandon Impérial",    region: "Champagne",  note: "brut",                price: 85 },
  { id: "veuve",        cat: "champagne", name: "Veuve Clicquot Yellow Label",region: "Champagne",  note: "brut",                price: 95 },
  { id: "billecart",    cat: "champagne", name: "Billecart-Salmon Brut Réserve", region: "Champagne", note: "brut",              price: 110 },
  { id: "dom_perignon", cat: "champagne", name: "Dom Pérignon",               region: "Champagne",  note: "prestige",            price: 320 },
  { id: "krug",         cat: "champagne", name: "Krug Grande Cuvée",          region: "Champagne",  note: "prestige",            price: 340 },
];

export const BYE_WINE_CATEGORIES = ["white", "red", "rose", "sparkling", "champagne"];

export const BYE_DEPOSIT_EUR = 50;
